import React, { useState, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Container, TextField, Button, TablePagination ,Snackbar} from "@mui/material";
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { TablePaginationActions } from '../../actions/TablePaginationActions';
import Axios from "axios";
import ErrorIcon from '@mui/icons-material/Error';
import { getBaseURL } from "../../baseURL";
import SearchIcon from '@mui/icons-material/Search';
import GetAppIcon from '@mui/icons-material/GetApp';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useSelector } from "react-redux";
import MuiAlert from '@mui/material/Alert';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const LocalReport = (props) => {
	const [cases, setCase] =  useState('local');
  const[fromDate, setFromDate] =  useState(new Date() );
  const[toDate, setToDate] = useState(new Date());
  const[results, setResults] = useState([]);
  const[loading, setLoading] = useState(false);
  const[pageloading, setPageLoading] = useState(false);
  const[submitted, setSubmitted] = useState(false);
  const[open, setOpen] = useState(false);
  const[sortDate, setSortDate] = useState(false);
  const[sortDateDesc, setSortDateDesc] = useState(true);
  const [page, setPage] = React.useState(0);
  const[rowsPerPage, setRowsPerPage] = useState(20);
  const [SnackBarOpen, setSnackBarOpen] = useState(false);
  const [SnackBarText, setSnackBarText] = useState("");
 
  const[isAdmin, setIsAdmin] = useState(null);
  const [fromDateError, setfromDateError] = useState({ Error: false, Text: "" });
  const [toDateError, settoDateError] = useState({ Error: false, Text: "" });
  const currentUser = useSelector(state => state.auth);
  const [AlertColor, setAlertColor] = useState("");
  const [totalCount, settotalCount] = useState(0);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  
  const config = {
    headers: {'Authorization': "Bearer " + currentUser.jwtIdToken.idToken}
  };

  const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(3, 2),
    },
    paperSpacing: {
      paddingTop: "30px",
    },
  }));

  useEffect(() => {
    if(isAdmin === null) {
        try {
            if(currentUser.user.permissions.find(p => p.permissionName === "System Admin").value === true) {
                setIsAdmin(true);
            }
            else {
                setIsAdmin(false);
            }
        }
        catch(error) {
            setIsAdmin(false);
        }

        if (!isAdmin) {
            try {
                if (currentUser.user.permissions.find(p => p.permissionName === "Special Access Admin").value === true) {
                    setIsAdmin(true);
                }
                else {
                    setIsAdmin(false);
                }
            }
            catch (error) {
                setIsAdmin(false);
            }
        }
    }
}, []);

  

 

  const onFromDateChange = fromDate => {
    setFromDate(fromDate);
  }

  const onToDateChange = toDate => {
    setToDate(toDate);
  }

  const changeLoadingStatus = (isLoading) => {
    setLoading(isLoading);
  }


  
  const onSubmit = (event) => {
    event.preventDefault();
    if (fromDate && toDate) {
    
    setSubmitted(false);
    setLoading(true);

    const formData = {
      Case: cases,
      StartDate: fromDate,
      EndDate: toDate,
      State:true
      
    }
    
      Axios.post(`${getBaseURL()}/admin/specialaccessreport`,formData,config).then(o => {                 
        
        if(o.data.report.length>0){
                setResults(o.data.report);
                settotalCount(o.data.totalCount);
              }else{
                setAlertColor("success")
                setSnackBarOpen(true)
                setSnackBarText("No Records found")  
            }         
                      
               setLoading(false); 
               setSubmitted(true);
              }).catch((error) => {
              setLoading(false)
              setSnackBarOpen(true);
              setSnackBarText(error.response.data.message);
              console.log(error.response.data.message);
      
        
      }).catch(err => {
         
      });
    
  
   
    
  

  }
 
  }


  const handleClose = () => {
    setOpen(false);
  }
  const getReports = (pageisze,rows) => {
    const formData = {
      
      StartDate: fromDate.toUTCString(),
      EndDate: toDate.toUTCString(),
      currentPage:pageisze,
      pageSize:rows
    }

    
      
  }
  const handleChangePage = (event, newPage) => {    
    setPage(newPage);
    setPageLoading(false);
    getReports(newPage,rowsPerPage);
   
  };

  const handleChangeRowsPerPage = event => {
    
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    getReports(0,parseInt(event.target.value, 10))
  }
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  }

  

  const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, results.length - page * rowsPerPage);

  const classes = useStyles();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Container maxWidth={false} disableGutters={true}>
      {isAdmin ?
        <Container maxWidth={false} disableGutters={true}>
          
          <Typography variant="h4" gutterBottom>Local Sourcing Report</Typography>
          <Paper className={classes.root}>
            
            <form onSubmit={onSubmit}>
              
              <br />
             
              <br />
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={(newValue) => onFromDateChange(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={(newValue) => onToDateChange(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
              <br />
              <Button variant="contained" type="submit" color="primary"><SearchIcon />&nbsp;Search Report</Button>
              &nbsp;&nbsp;&nbsp;
              
            </form>
          </Paper>
          <br />
          {loading ? <CircularProgress style={{ marginLeft: '50%' }} /> : null}

          <br />
          <br />
          {(submitted && !loading && results.length > 0) &&
            <Paper className={`${classes.root} ${'MuiPaper-elevation4'} ${classes.paperSpacing}`} p={5} style={{ overflow: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Requested By</TableCell>
                    <TableCell>Drawing Number</TableCell>
                     <TableCell>Class Level</TableCell>
				          	<TableCell>Description</TableCell>
                    <TableCell>Print Requested</TableCell>
                    <TableCell>Print Approved</TableCell>
                    <TableCell>Case Number</TableCell>
                    <TableCell>Approval Number</TableCell>
                    <TableCell>Business Justification</TableCell>
					<TableCell>Request Date</TableCell>
					<TableCell>Effective Date</TableCell>
          <TableCell>Duration</TableCell>
					<TableCell>Expiration Date</TableCell>
                    <TableCell>Is Approved</TableCell>
                    <TableCell>Actioned On</TableCell>
                    <TableCell>Actioned By</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {results.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                    return (
                        <TableRow key={index}>
                       <TableCell>{item.usermail}</TableCell>
                       <TableCell>{item.drawingNumber}</TableCell>
					   <TableCell>{item.classLevel}</TableCell>
					   <TableCell>{item.partDescription}</TableCell>
                       <TableCell>{item.printRequested ? 'Yes' : 'No'}</TableCell>
                       <TableCell>{item.printApproved ? 'Yes' : 'No'}</TableCell>
                       <TableCell>{item.businessNeedDescription}</TableCell>
                       <TableCell>{item.businessApprovalNumber}</TableCell>
                       <TableCell>{item.businessNeedJustification}</TableCell>
					   <TableCell>{item.requestDate}</TableCell>
					   <TableCell>{item.effectiveDate}</TableCell>
              <TableCell>{item.duration ? `${item.duration} days` : ''}</TableCell>
                       <TableCell>{item.accessExpirationDate}</TableCell>
                       <TableCell>{item.state ? 'Yes' : 'No'}</TableCell>
                       <TableCell>{item.actionDate}</TableCell>
                       <TableCell>{item.email}</TableCell>
                        
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[10, 15, 20, 25, 50]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'previous page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'next page',
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />

            </Paper>
          }
          {pageloading ? <CircularProgress style={{ width: '40px', height: '40px', position: 'fixed', left: '50%', top: '50%' }} />
            : null}
          <Snackbar
            open={SnackBarOpen}
            autoHideDuration={8000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert onClose={handleSnackbarClose} severity={AlertColor === "success" ? "success" : "error"}>
              {SnackBarText}
            </Alert>
          </Snackbar>
        </Container>
        :
        <Paper className={classes.root}>
          <Typography variant="h6">
            <ErrorIcon />&nbsp;Access Denied
          </Typography>
        </Paper>
      }
    </Container>
  </LocalizationProvider>
  );
}